export class Cargo {
    idCargo: any;
    nomeCargo: any;
    flAtivo: any;
    
    constructor() {
        this.idCargo = "";
        this.nomeCargo = "";
        this.flAtivo = true;
    }
}


// WEBPACK FOOTER //
// ./src/models/Cargo.ts